<div class="border py-6 px-4 bg-white rounded-lg">
  <div class="flex justify-center mb-3">
    <wu-avatar className="w-20" />
  </div>
  <p
    class="text-center font-notoserif font-semibold mb-3 text-walden-500 md:text-xl"
  >
    {{ user()?.displayName }}
  </p>

  <p class="text-center">ID Number: {{ studentId() }}</p>

  <div class="py-6 text-walden-500">
    <a
      routerLink="/my-account"
      class="flex justify-between items-center py-3 gap-4 border-b hover:bg-walden-200"
    >
      <p class="font-bold">My Account</p>
      <div class="p-2 bg-[#FDB71A] rounded-full">
        <wu-icon name="rightArrowIcon" />
      </div>
    </a>
    <a
      class="flex justify-between items-center py-3 gap-4 border-b hover:bg-walden-200 cursor-pointer"
      (click)="openSheduleMeet($event)"
    >
      <p class="font-bold">Schedule An Appointment</p>
      <div class="p-2 bg-[#FDB71A] rounded-full">
        <wu-icon name="rightArrowIcon" />
      </div>
    </a>
    <a
      routerLink="/support"
      [queryParams]="{ tab: 'contact-directory' }"
      class="flex justify-between items-center py-3 gap-4 hover:bg-walden-200"
    >
      <p class="font-bold">Contact Directory</p>
      <div class="p-2 bg-[#FDB71A] rounded-full">
        <wu-icon name="rightArrowIcon" />
      </div>
    </a>
  </div>

  <div class="flex justify-center">
    <button
      type="button"
      class="text-center hover:underline font-bold text-walden-500"
      (click)="logout()"
    >
      Logout
    </button>
  </div>
  @if (showScheduleMeetModal()) {
    <div>
      <wu-schedule-meeting
        className="max-w-xl"
        [environmentDetails]="environmentDetails"
        [scheduleAppointmentID]="scheduleAppointmentID"
        (clicked)="closeModal()"
      />
    </div>
  }
</div>
